// extracted by mini-css-extract-plugin
export default {"comments":"CommentsList_comments__Grrzd"};